module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f162d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/template/200.vue
// module id = 1427
// module chunks = 45